import {
  INCREMENT_PAGE_RESIZE_COUNTER,
  UPDATE_SPACE_UTILIZED,
  USER_CHANGED_MANIFOLD_TAB,
} from '../context/controls/actionCreator';
import {
  ManifoldTabEnum,
  ManifoldTabEnumBottomToolbar,
  ManifoldTabEnumMiscellaneous,
} from './toolpane';

export interface ControlState {
  activeManifold: ManifoldTabEnum | ManifoldTabEnumBottomToolbar | ManifoldTabEnumMiscellaneous;
  totalSpaceOccupied: number;
  pageResizeCounter: number;
}

export interface SetActiveManifold {
  type: typeof USER_CHANGED_MANIFOLD_TAB;
  payload: {
    active: ManifoldTabEnum | ManifoldTabEnumBottomToolbar | ManifoldTabEnumMiscellaneous;
  };
}

export interface UpdateSpaceUtilized {
  type: typeof UPDATE_SPACE_UTILIZED;
  payload: number;
}

export interface IncrementPageNo {
  type: typeof INCREMENT_PAGE_RESIZE_COUNTER;
}

export type ControlActionTypes = SetActiveManifold | UpdateSpaceUtilized | IncrementPageNo;

export const MANIFOLD_TAB_SEQ = Object.values(ManifoldTabEnum);
export const MANIFOLD_TAB_SEQ_BOTTOM_TOOLBAR = Object.values(ManifoldTabEnumBottomToolbar);
export const MANIFOLD_TAB_SEQ_MISCELLANEOUS = Object.values(ManifoldTabEnumMiscellaneous);
